module.exports = __webpack_public_path__ + "img/download03.44d2de55.png";